import React, { useEffect, useState } from "react";
import SingleProductFixed from "../../../shared-components/SingleProductFixed/SingleProductFixed";
import { Link, NavLink } from "react-router-dom";

import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path
import {
  bidAuction,
  cancelAuction,
  fetchAuctions,
  fetchFixedListings,
} from "../../../utilis/web3";
import { useAccount } from "wagmi";
import SingleProduct from "../../../shared-components/SingleProduct/SingleProduct";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Explore() {
  AnimationFileLoader();

  const [fixedListing, setFixedListing] = useState();
  const [auctionListing, setAuctionListing] = useState();
  const { address, isConnected } = useAccount();
  const [selectedCollection, setSelectedCollection] =
    useState("all_collection");

  const changeFixedListing = (tokenIdToRemove) => {
    setFixedListing((prevListing) => {
      const updatedListing = { ...prevListing };
      delete updatedListing[tokenIdToRemove];
      return updatedListing;
    });
  };

  const handlePlaceBid = async (tokenId, auctionPrice, currentPrice) => {
    const placeBid = await bidAuction(
      address,
      tokenId,
      auctionPrice,
      currentPrice
    );
    if (placeBid) {
      await fetchData();
    }
  };

  const handleCancelAuction = async (tokenId) => {
    const auctionCancelled = await cancelAuction(address, tokenId);
    if (!auctionCancelled) {
      setAuctionListing((prevAuctionListing) => {
        const updatedAuctionListing = { ...prevAuctionListing };
        delete updatedAuctionListing[tokenId];
        return updatedAuctionListing;
      });
    }
  };

  const fetchData = async () => {
    const data = await fetchFixedListings();
    const auctionData = await fetchAuctions();
    if (data) {
      setFixedListing(data);
    }

    if (auctionData) {
      // console.log("auctionData", auctionData)
      setAuctionListing(auctionData);
    }
  };

  useEffect(() => {
    fetchData();
  }, [address]);

  return (
    <>
      {/* Author */}
      <div className="author-area">
        <div
          className="author-cover"
          data-bg-img="/img/bg/author-cover.png"
        ></div>
      </div>
      {/* End Author */}

      {/* Explore */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row mb-50">
            <div className="col-lg-8 order-1 order-lg-0">
              <div className="filter-options d-flex flex-wrap justify-content-center justify-content-lg-start">
                <select
                  className="select-rounded mb-10 lg me-4"
                  value={selectedCollection}
                  onChange={(e) => setSelectedCollection(e.target.value)}
                >
                  <option value="all_collection">All Collection</option>
                  <option value="art_collection">Art Collection</option>
                  <option value="music_collection">Music Collection</option>
                  <option value="digital_collection">Digital Collection</option>
                  <option value="utility_collection">Utility Collection</option>
                  <option value="fashion_collection">Fashion Collection</option>
                </select>

                {/* <select className="select-rounded mb-10 lg me-4">
                  <option value="buy_now">Buy now</option>
                  <option value="sell">Sell</option>
                  <option value="pending">Pending</option>
                </select>

                <select className="select-rounded mb-10 lg">
                  <option value="following">All items</option>
                  <option value="miscellaneous ">Miscellaneous </option>
                  <option value="virtual_fashion">Virtual Fashion</option>
                  <option value="domain_names">Domain Names</option>
                  <option value="sports_moments">Sports Moments</option>
                  <option value="memes">Memes</option>
                </select> */}
              </div>
            </div>

            {/* <div className="col-lg-4 order-0 order-lg-1">
              <form className="search-form style--two mb-4 mb-lg-2" action="#">
                <div className="form-group ms-auto me-auto me-lg-0 mw-100">
                  <input
                    type="text"
                    className="form-control mb-0"
                    placeholder="Search item…"
                  />
                  <button type="submit">
                    <img src="/img/icons/search.svg" className="svg" alt="" />
                  </button>
                </div>
              </form>
            </div> */}
          </div>

          <div className="container mt-60 mt-lg-0">
            {fixedListing && Object.keys(fixedListing).length > 0 ? (
              <>
                <div className="row justify-content-center">
                  <div className="col-lg-7">
                    {/* Section Title  */}
                    <div className="section-title text-white text-center">
                      <h2>Live Sales</h2>
                      <p>
                        NFTs, or non-fungible tokens, represent distinct digital
                        assets characterized by their uniqueness, rendering them
                        irreplaceable with alternative items.
                      </p>
                    </div>
                    {/* End Section Title  */}
                  </div>
                </div>
                <div className="row justify-content-center align-items-center">
                  {Object.keys(fixedListing).map((tokenId, index) => {
                    const nft = fixedListing[tokenId];
                    if (
                      selectedCollection === "all_collection" ||
                      nft.collection === selectedCollection
                    ) {
                      return (
                        <div
                          className="col-lg-4 col-md-6 justify-content-center align-items-center"
                          key={index}
                          style={{
                            height: "200px",
                          }}
                        >
                          <SingleProductFixed
                            classList="single-product d-flex flex-column justify-content-center align-items-center h-50 mt-5"
                            productPrice={nft?.price}
                            address={address}
                            tokenId={tokenId}
                            imgSrc={nft?.image}
                            supply={nft?.supply}
                            blockchain={nft?.blockchain}
                            name={nft?.name}
                            changeFixedListing={changeFixedListing}
                            collection={nft?.collection}
                            description={nft?.description}
                            listed={nft?.listed}
                            seller={nft?.seller}
                          />
                        </div>
                      );
                    }
                    return null;
                  })}

                  {/* <div className="col-lg-12 d-flex justify-content-center mt-30">
                    <NavLink to="#" className="btn">
                      <img
                        src="/img/icons/btn-loadmore.svg"
                        alt=""
                        className="svg"
                      />{" "}
                      Load More
                    </NavLink>
                  </div> */}
                </div>
              </>
            ) : (
              <div className="row justify-content-center">
                <div className="col-lg-7 text-center">
                  {/* Section Title  */}
                  <div className="section-title text-white text-center">
                    <h2>No Live Sales Yet</h2>
                    <p>Please try again later or mint and list your own NFT.</p>
                  </div>
                  <Link
                    type="button"
                    to="/explore/wallet"
                    className="btn btn-primary mx-auto"
                  >
                    Wallet
                  </Link>
                  {/* End Section Title  */}
                </div>
              </div>
            )}
          </div>
          <div className="container mt-60 mt-lg-5">
            {auctionListing && Object.keys(auctionListing).length > 0 ? (
              <>
                <div className="row justify-content-center  ">
                  <div className="col-lg-7">
                    {/* Section Title  */}
                    <div className="section-title text-white text-center">
                      <h2>Live Auctions</h2>
                    </div>
                    {/* End Section Title  */}
                  </div>
                </div>
                <div className="row" style={{ marginTop: "50px" }}>
                  {Object.keys(auctionListing).map((tokenId, index) => {
                    const nft = auctionListing[tokenId];
                    if (
                      selectedCollection === "all_collection" ||
                      nft.collection === selectedCollection
                    ) {
                      return (
                        <div
                          className="col-lg-4 col-md-6"
                          key={index}
                          style={{
                            height: "200px",
                            marginTop: "150px",
                          }}
                        >
                          <SingleProduct
                            classList="single-product d-flex flex-column justify-content-center align-items-center h-50 mt-5"
                            currentBid={nft?.currentPrice}
                            address={address}
                            tokenId={tokenId}
                            highestBidder={nft?.highestBidder}
                            imgSrc={nft?.image}
                            endTime={nft?.endTime?.split(",")[0]}
                            supply={nft?.supply}
                            blockchain={nft?.blockchain}
                            name={nft?.name}
                            handlePlaceBid={handlePlaceBid}
                            handleCancelAuction={handleCancelAuction}
                            collection={nft?.collection}
                            description={nft?.description}
                            seller={nft?.seller}
                          />
                        </div>
                      );
                    }
                    return null;
                  })}

                  {/* <div className="col-lg-12 d-flex justify-content-center mt-30">
                    <NavLink to="#" className="btn">
                      <img
                        src="/img/icons/btn-loadmore.svg"
                        alt=""
                        className="svg"
                      />{" "}
                      Load More
                    </NavLink>
                  </div> */}
                </div>
              </>
            ) : (
              <div className="row justify-content-center">
                <div className="col-lg-7 text-center">
                  {/* Section Title  */}
                  <div className="section-title text-white text-center">
                    <h2>No Live Auctions Yet</h2>
                    <p>
                      Please try again later or mint and auction out your own
                      NFT.
                    </p>
                  </div>
                  <Link
                    type="button"
                    to="/explore/wallet"
                    className="btn btn-primary mx-auto"
                  >
                    Wallet
                  </Link>
                  {/* End Section Title  */}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* End Explore */}
    </>
  );
}

export default Explore;
